export enum ComponentSize {
  LARGE = 'L',
  MEDIUM = 'M',
  SMALL = 'S',
}
